
export default {
  name: "ContentType1",
  props: {
    introList: {
      type: Array,
      default () {
        return []
      }
    },
    contentStyle: {
      type: Object,
      default () {
        return {}
      }
    },
    classProps: {
      type: String,
      default: ''
    }
  }
}
